import type { Style } from '@react-pdf/types'

type PdfContentItem = {
  text: string
  style?: Style
}

type PdfContent = Record<string, PdfContentItem>

export const PDF_CONTENT: PdfContent = {
  headerTitle: {
    text: 'RAPORT',
    style: { fontSize: 18, fontWeight: 'bold' }
  },
  title: {
    text: 'KONDYCJI ENERGETYCZNEJ ZESPOŁU',
    style: {
      fontSize: 26,
      fontFamily: 'OpenSans',
      fontWeight: 'bold',
      // letterSpacing: 1.5,
      paddingHorizontal: 20,
      textAlign: 'center'
    }
  },
  paragraf_1_1: {
    text: 'Każda organizacja funkcjonuje w określonym tempie. Realizuje projekty, podejmuje decyzje, odpowiada na presję rynku. Za tym tempem stoi jednak coś mniej widocznego - codzienna energia ludzi, którzy tę pracę wykonują.',
    style: {
      marginTop: -100
    }
  },
  paragraf_1_2: {
    text: 'Niniejszy raport przedstawia obraz kondycji zespołu na podstawie anonimowej ankiety obejmującej obszary regeneracji, snu, aktywności oraz codziennych nawyków. Nie jest to dokument medyczny. To spojrzenie na firmę przez pryzmat jej rzeczywistej wydolności operacyjnej czyli zdolności do utrzymania stabilnej efektywności w czasie.'
  },
  paragraf_1_3: {
    text: 'Energia zespołu wpływa bezpośrednio na koncentrację, jakość decyzji, odporność na stres i tempo realizacji zadań. Gdy jest stabilna - organizacja działa płynnie. Gdy zaczyna się wyczerpywać - pojawiają się drobne sygnały, które z czasem mogą wpływać na większe obszary funkcjonowania.'
  },
  paragraf_1_4: {
    text: 'Celem analizy jest zidentyfikowanie aktualnego poziomu rezerw energetycznych zespołu, wskazanie obszarów wymagających uwagi oraz określenie kierunku działań, które mogą wzmocnić stabilność organizacji w najbliższych miesiącach.'
  },
  paragraf_1_5: {
    text: 'Ten Raport nie ocenia, tylko pokazuje. Nie narzuca, tylko wskazuje możliwości.',
    style: {
      fontWeight: 'bold'
    }
  },
  wynik_subtitle_1: {
    text: 'AKTUALNY WYNIK RAPORTU'
  },
  p_wynik_2_1: {
    text: 'OBRAZ OGÓLNY'
  },
  p_wynik_2_2_1: {
    text: 'Średni wynik zespołu wyniósł:',
    style: {
      fontSize: 15,
    }
  },
  p_wynik_2_2_2: {
    text: 'Aktualnie'
  },
  p_wynik_2_2_3: {
    text: 'zespołu funkcjonuje bez pełnej rezerwy energetycznej, co w dłuższej perspektywie może ograniczać odporność zespołu na wzrost obciążeń.'
  },
  p_wynik_2_3: {
    text: 'Dodatkowo:',
    style: {
      marginTop: 10
    }
  },
  li_wynik_2_3_1: {
    text: 'pracowników znajduje się w strefie „SŁABO” :',
    style: {
      padding: 6
    }
  },
  li_wynik_2_3_2: {
    text: 'w strefie „ŚREDNIO”:',
    style: {
      padding: 6
    }
  },
  li_wynik_2_3_3: {
    text: 'w strefie „SUPER”:',
    style: {
      padding: 6
    }
  },
  strefa_1: {
    text: 'Strefa „SŁABO” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_1_1: {
    text: 'Osoby w tej strefie funkcjonują na obniżonym poziomie energii i regeneracji. Widoczne są symptomy przewlekłego zmęczenia oraz kumulacja niekorzystnych nawyków, co zwiększa podatność na przeciążenie w okresach intensywnej pracy. To grupa wymagająca priorytetowego wsparcia.',
    style: {
      fontSize: 12
    }
  },
  strefa_2: {
    text: 'Strefa „ŚREDNIO” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_2_1: {
    text: 'Pracownicy w tej strefie realizują swoje obowiązki stabilnie, jednak ich funkcjonowanie nie opiera się na pełnej rezerwie energetycznej. Występują pojedyncze obszary wymagające korekty, które w dłuższej perspektywie mogą obniżać wydolność. To grupa o największym potencjale poprawy przy relatywnie niewielkiej interwencji.',
    style: {
      fontSize: 12
    }
  },
  strefa_3: {
    text: 'Strefa „SUPER” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_3_1: {
    text: 'Osoby w tej strefie wykazują stabilne nawyki wspierające energię i regenerację. Ich codzienne funkcjonowanie sprzyja utrzymaniu koncentracji oraz odporności na stres. Stanowią naturalny fundament stabilności operacyjnej organizacji.',
    style: {
      fontSize: 12
    }
  },
  signals: {
    text: 'Wskaźniki Znaczących Sygnałów',
    style: {
      margin: 0,
      paddingVertical: 0
    }
  },
  signals_1: {
    text: 'Wskaźniki opisujące główne czynniki ryzyka energetycznego zespołu',
    style: {
      fontSize: 11,
      margin: 0,
      paddingVertical: 0,
      paddingBottom: 30,
      lineHeight: 1
    }
  },
  summary: {
    text: 'Co to oznacza dla firmy?',
    style: {
      fontWeight: 'bold',
      textAlign: 'center'
    }
  },

  p_summary_1_1: {
    text: 'Wyniki wskazują, że organizacja posiada stabilną rezerwę energetyczną zespołu. Codzienne nawyki pracowników w dużej mierze wspierają regenerację, koncentrację oraz odporność na stres.'
  },
  p_summary_1_2: {
    text: 'W praktyce oznacza to:'
  },
  li_summary_1_2_1: {
    text: 'większą elastyczność w okresach wzmożonego obciążenia,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_2: {
    text: 'szybszą regenerację po intensywnych projektach,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_3: {
    text: 'stabilniejsze tempo realizacji zadań,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_4: {
    text: 'mniejsze ryzyko nagłych spadków wydolności operacyjnej.',
    style: {
      paddingVertical: 0
    }
  },
  p_summary_1_3: {
    text: 'Obecny poziom stanowi realny atut organizacyjny. Kluczowe jest jego utrzymanie oraz dalsze wzmacnianie obszarów, które budują długoterminową stabilność zespołu.'
  },
  p_summary_1_4: {
    text: 'Działania w tym zakresie mają charakter rozwojowy – pozwalają utrzymać przewagę operacyjną w dynamicznym środowisku biznesowym.'
  },

  p_summary_2_1: {
    text: 'Organizacja funkcjonuje stabilnie, jednak część zespołu działa bez pełnej rezerwy energetycznej. W okresach zwiększonego obciążenia może to ograniczać odporność operacyjną firmy.'
  },
  p_summary_2_2: {
    text: 'Największy potencjał poprawy dotyczy codziennych nawyków, szczególnie w obszarze regeneracji i stabilizacji energii w ciągu dnia.'
  },
  p_summary_2_3: {
    text: 'Działania na tym etapie mają charakter prewencyjny i mogą istotnie wzmocnić odporność organizacji w najbliższych miesiącach.'
  },

  p_summary_3_1: {
    text: 'Wyniki wskazują na istotne ograniczenie rezerwy energetycznej zespołu. Znaczna część pracowników funkcjonuje w trybie kompensacyjnym, co w dłuższej perspektywie może zwiększać podatność organizacji na przeciążenie.'
  },
  p_summary_3_2: {
    text: 'W praktyce oznacza to:'
  },
  li_summary_3_2_1: {
    text: 'mniejszą odporność na presję i intensywne projekty,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_3_2_2: {
    text: 'wolniejszą regenerację po okresach zwiększonego obciążenia,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_3_2_3: {
    text: 'wyższe ryzyko absencji i spadku stabilności operacyjnej.',
    style: {
      paddingVertical: 0
    }
  },
  p_summary_3_3: {
    text: 'Na tym etapie rekomendowane są działania wzmacniające podstawowe filary regeneracji – sen, aktywność oraz stabilizację energii poprzez codzienne nawyki żywieniowe.'
  },

  p_end_1: {
    text: 'Energia zespołu – przestrzeń do świadomych decyzji',
    style: {
      fontWeight: 'bold',
      textAlign: 'center'
    }
  },
  p_end_1_1: {
    text: 'Każda firma funkcjonuje w określonym tempie. Projekty, terminy, odpowiedzialność – to naturalna część pracy. Jednak za tym tempem stoi coś mniej widocznego: codzienna wydolność ludzi, którzy te zadania realizują.'
  },
  p_end_1_2: {
    text: 'Wyniki badania pokazują, że stabilność tej wydolności nie jest wyłącznie kwestią motywacji czy kompetencji. W dużej mierze zależy od prostych, powtarzalnych nawyków – snu, ruchu, sposobu odżywiania oraz jakości przerw w ciągu dnia.'
  },
  p_end_1_3: {
    text: 'W wielu organizacjach kalendarze są wypełnione od rana do wieczora. Przerwy są skracane, posiłki odkładane, a zmęczenie traktowane jako naturalny element pracy. W krótkim okresie zespół daje sobie radę. W dłuższym – zaczyna funkcjonować bez bezpiecznej rezerwy.'
  },
  p_end_1_4: {
    text: 'Środowisko pracy ma w tym procesie znaczenie większe, niż się wydaje. Może sprzyjać regeneracji, mikroaktywności i świadomym wyborom żywieniowym. Może też – nieświadomie – utrwalać nawyki, które stopniowo obniżają stabilność organizacyjną.'
  },
  p_end_1_5: {
    text: 'Szczególnie istotny jest obszar odżywiania. Wahania koncentracji czy spadki energii po południu często nie wynikają z braku zaangażowania, lecz z nieregularnych posiłków i niestabilnego poziomu energii w ciągu dnia. Coraz więcej firm zauważa, że wspieranie pracowników w budowaniu lepszych nawyków żywieniowych nie jest benefitem wizerunkowym, lecz elementem dbania o wydolność operacyjną.'
  },
  p_end_1_6: {
    text: 'Nie chodzi o kontrolę czy narzucanie stylu życia. Chodzi o stworzenie warunków, które ułatwiają podejmowanie lepszych decyzji – tych małych, codziennych. To one, powtarzane tygodniami, wzmacniają lub osłabiają kondycję całej organizacji.'
  },
  p_end_2: {
    text: 'Energia zespołu nie jest abstrakcją. To realny zasób. A zasobami strategicznymi się zarządza.',
    style: {
      flex: 1,
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'justify',
      color: '#97931a'
    }
  }
} satisfies Record<string, PdfContentItem>
